import { Link } from "@tanstack/react-router";

import { useStationPage } from "../components/StationLayout";

/**
 * The DJs tab: every DJ on the station as a card, tiled like the shows
 * (see .station__cards).
 */
const DjsList = () => {
  const { stationSlug, directory } = useStationPage();

  if (!directory) {
    return <p className="station__quiet mono">Loading…</p>;
  }
  if (directory.djs.length === 0) {
    return <p className="station__quiet mono">This station has no DJs yet</p>;
  }

  return (
    <ul className="station__cards">
      {directory.djs.map((dj) => (
        <li key={dj.slug} className="station__card">
          <Link
            to="/$stationSlug/djs/$djSlug"
            params={{ stationSlug, djSlug: dj.slug }}
          >
            {dj.image_url && (
              <img
                className="station__card-art station__card-art--round"
                src={dj.image_url}
                alt=""
              />
            )}
            <span className="station__card-name">{dj.name}</span>
          </Link>
        </li>
      ))}
    </ul>
  );
};

export default DjsList;
